import { showDumpStation } from '../../util/api';
import { storableError } from '../../util/errors';

// Action types
const SHOW_REQUEST = 'app/DumpStationPage/SHOW_REQUEST';
const SHOW_SUCCESS = 'app/DumpStationPage/SHOW_SUCCESS';
const SHOW_ERROR = 'app/DumpStationPage/SHOW_ERROR';

/** @type {import('../../../types/vansite').VanSite.State.DumpStationPage} */
const initialState = {
  station: null,
  showStationInProgress: false,
  showStationError: null,
};

const reducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SHOW_REQUEST:
      return { ...state, showStationInProgress: true, showStationError: null };
    case SHOW_SUCCESS:
      return { ...state, station: payload, showStationInProgress: false };
    case SHOW_ERROR:
      return { ...state, showStationInProgress: false, showStationError: payload };
    default:
      return state;
  }
};

export default reducer;

// Action creators
const showRequest = () => ({ type: SHOW_REQUEST });
const showSuccess = (station) => ({ type: SHOW_SUCCESS, payload: station });
const showError = (e) => ({ type: SHOW_ERROR, payload: e, error: true });

// Thunks
export const loadData = (params) => async (dispatch) => {
  dispatch(showRequest());
  try {
    const response = await showDumpStation(params.id);
    dispatch(showSuccess(response.data));
  } catch (e) {
    dispatch(showError(storableError(e)));
  }
};
